const ScriptShow = ({ script, onScriptSelect, sstEnv }) => {
  let scriptName = script.script;
  let done = <img src="../done.png" alt="yes" width="25" height="25" />;
  let noDone = (scriptName, env) => {
    return (
      <div
        onClick={() => onScriptSelect(scriptName, env, sstEnv)}
        className="notDone"
      >
        <img src="../notdone.png" alt="no" width="25" height="25" />
      </div>
    );
  };
  let dev = script.dev ? done : noDone(scriptName, "dev");
  let qa = script.qa ? done : noDone(scriptName, "qa");
  let uat = script.uat ? done : noDone(scriptName, "uat");
  let prod = script.prod ? done : noDone(scriptName, "prod");

  return (
    <tr>
      <td className="tcell">{scriptName}</td>
      <td>{dev}</td>
      <td>{qa}</td>
      <td>{uat}</td>
      <td>{prod}</td>
    </tr>
  );
};

export default ScriptShow;
